export default __webpack_public_path__ + "static/media/angela2.884ebdd0.jpg";